import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from '../dashboard/dashboard/dashboard.component';
import { AuthGuardService } from '../auth/auth-guard.service';
import { MobileAppSubscriptionsComponent } from './mobile-app-subscriptions/mobile-app-subscriptions.component';
import { ReviewInvitationsComponent } from './review-invitations/review-invitations.component';
import { DistributorGuardService } from './distributor-guard.service';

const distributorRoutes: Routes = [
    { path: '', children: [
        { path: '', component: DashboardComponent},
        // tslint:disable-next-line: max-line-length
        { path: 'mobile-app-subscriptions', component: MobileAppSubscriptionsComponent, canActivate: [AuthGuardService, DistributorGuardService]},
        { path: 'review-invitations', component: ReviewInvitationsComponent, canActivate: [AuthGuardService, DistributorGuardService]},
    ]
    }
  ];

@NgModule({
  imports: [RouterModule.forChild(distributorRoutes)],
  exports: [RouterModule]
})
export class DistributorRoutingModule { }
